module.exports = __webpack_public_path__ + "media/main.93cf6256.mp4";